module.exports = __webpack_public_path__ + "img/orange_070.7a670454.png";